module.exports = __webpack_public_path__ + "static/media/icon-list-dark.31c09371.svg";